import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/css/tailwind.css';
import Admin from 'layouts/Admin';

ReactDOM.render(
  <React.StrictMode>
    <Admin />
  </React.StrictMode>,
  document.getElementById('root')
);
